export default __webpack_public_path__ + "static/media/cpp.f7421b11.svg";